import { connectedLimitOrderSections } from 'components/secondaryMarket/limitOrder/sections.connect';

export const LimitOrderPostEventSections = connectedLimitOrderSections('secondaryMarketPostEvents');
